import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HEADER_NAME } from '../../common/constants.js';


const HeaderTitle = (props) => {
    let height;
    let hederHeight = 64;
    let textheight;
    let bottom;
    if(props.current === 4 || props.current === 5){
        textheight = 40;
        height = (hederHeight - textheight) / 2 + "px";
        bottom = 0 + "px" 
    }else{
        textheight = 20;
        height = (hederHeight - textheight) / 2 + "px";
        bottom = 10 + "px"
    }
    return(
        <Body>
            <Title Height={height}>
                <TitleText  dangerouslySetInnerHTML={{ __html: HEADER_NAME[props.current]}} />
                <TitleIcon Bottom={bottom} onClick={props.onClickHome}>
                    ＜
                </TitleIcon>
            </Title>
        </Body>
    );
}

export { HeaderTitle };

HeaderTitle.propTypes = {
    current: PropTypes.number.isRequired,
    onClickHome: PropTypes.func.isRequired,
};

const Body = styled.div`
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: center;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    background-color:#f2f2f2;
`;
const Title = styled.div`
    position: relative;
    width:100%;
    height:64px;
    margin-top:${props => props.Height};   
`;
const TitleText = styled.div`
    position: absolute;
    width:100%;
    text-align:center;
    font-size: 20px;
    background-color:#f2f2f2;
    line-height:20px;
`;
const TitleIcon = styled.div`
    position: absolute;
    width: 35px;
    height: 64px;
    font-size: 30px;
    color: #00b050;
    margin-left: 10px;
    bottom: ${props => props.Bottom};
`;
